import { render, staticRenderFns } from "./Limburg.vue?vue&type=template&id=b40e76c6&"
var script = {}
import style0 from "./Limburg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Limburg.vue"
export default component.exports